export const AssignedPositions_TABLE_TITLE = 'Client level Securities';
export const UserManagement_TABLE_INFO_URL = '';
